import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    modals: [
      {
        type  : 'suggest_news_modal',
        active: false,
      },
      {
        type  : 'add_comment_modal',
        active: false,
      },
      {
        type  : 'modal_comment_edit',
        active: false,
      },
      {
        type  : 'modal_event_reg',
        active: false,
      },
    ],
    current_item_news: {},
    event_types      : [
      {text: 'Онлайн', name: 'online'},
      {text: 'Офлайн', name: 'offline'},
      {text: 'Офлайн с онлайн трансляцией', name: 'online_reg'},
    ],
    news_content: {
      type: 'news',
    },
    selected_number  : 10,
    selected_page    : 1,
    edited_comment_id: null,

    comments: [],
  },
  getters: {
    suggest_news_modal: ({modals}) => modals.find((modal)=> modal.type == 'suggest_news_modal').active,
    add_comment_modal : ({modals}) => modals.find((modal)=> modal.type == 'add_comment_modal').active,
    modal_comment_edit: ({modals}) => modals.find((modal)=> modal.type == 'modal_comment_edit').active,
    modal_event_reg   : ({modals}) => modals.find((modal)=> modal.type == 'modal_event_reg').active,
    selected_number   : ({selected_number}) => selected_number,
    selected_page     : ({selected_page}) => selected_page,
    edited_comment_id : ({edited_comment_id}) => edited_comment_id,
    get_comment_by_id : ({comments=[], edited_comment_id}) => (id) => {
      if (comments.length) {
        return comments.find((comment) => comment.id == id);
      }
    },
    current_edited_comment: ({}, {get_comment_by_id, edited_comment_id}) => {
      return get_comment_by_id(edited_comment_id);
    },
    news_content     : ({news_content}) => news_content,
    comments         : ({comments}) => comments,
    current_id       : ({news_content}) => news_content.id,
    current_item_news: ({current_item_news}) => current_item_news,
    new_comment      : ({news_content}) => news_content.new_comment,
    form_registration: ({}, getters, rootState) => {
      return rootState.registration_event.form.user_id;
    },
    comments_paginated({comments=[], selected_number, selected_page}) {
      // selected_number => selected list size to display
      // selected_page => page number in pagination
      if (comments.length) {
        return comments.slice((selected_number*(selected_page-1)), selected_number*selected_page);
      }
    },
  },
  mutations: {
    CLOSE_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      modal.active = false;
    },
    OPEN_MODAL(state, type) {
      let modal = state.modals.find((modal)=> modal.type === type);
      if (!modal.active) {
        modal.active = true;
      }
    },
    TOGGLE_NEWS_DETAIL_FAVOURITE(state) {
      state.news_content.favourite = !state.news_content.favourite;
    },
    SET_CURRENT_ID(state, id) {
      state.current_id = id;
      state.current_item_news = state.news.filter((x )=> x.id == id)[0];
    },
    EDIT_COMMENT_TEXT(state, obj) {
      const {id, value} = obj;
      const comment = state.comments.find((comment)=> comment.id === id);
      if (comment) {
        comment.text = value;
      }
    },
    DELETE_COMMENT(state, obj) {
      const {id, reason} = obj;
      let deleted_comment = {
        text: reason,
      };
      let commentId = state.comments.findIndex((comment)=> comment.id === id);
      if (reason) {
        state.comments = state.comments.slice(0, commentId).concat(deleted_comment, state.comments.slice(commentId+1, state.comments.length));
      } else {
        state.comments = state.comments.slice(0, commentId).concat(state.comments.slice(commentId+1, state.comments.length));
      }
    },
    SET_EDITED_ID(state, id) {
      state.edited_comment_id = id;
    },
    PUSH_COMMENT(state, obj) {
      if (state.news_content.new_comment.comment_item.length) {
        state.comments.push(state.news_content.new_comment);
      }
    },
    SET_NEWS_DETAIL(state, value) {
      value.registered = value.registered || false;
      state.news_content = value;

      let date = state.news_content.date;
      if (typeof date== 'object') {
        state.news_content.date.forEach((y)=>y.date = y.date*1000);
      } else {
        state.news_content.date = date*1000;
      }
    },
    SET_NEWS_CONTENT_REGISTERED(state) {
      state.news_content.registered = true;
    },
    SET_COMMENTS(state, value) {
      state.comments = value;
      if (state.comments.length > 0 ) {
        state.comments.forEach((x)=> x.date = x.date*1000);
      }
    },
    ADD_COMMENT(state, comment) {
      if (Array.isArray(state.comments[0])) {
        state.comments.push(comment);
      } else {
        state.comments[0] = comment;
      }
    },
    SET_SELECTED_PAGE(state, value) {
      state.selected_page = value;
    },
    CLEAR_PAGES(state) {
      state.selected_page = 1;
    },
    SHOW_NUMBER(state, obj) {
      const {array, selected} = obj;
      if (selected=='Показывать по 10') {
        state.selected_number = 10;
      } else if (selected=='Показывать по 25') {
        state.selected_number = 25;
      } else if (selected=='Показывать по 50') {
        state.selected_number = 50;
      } else if (selected=='Показывать по 100') {
        state.selected_number = 100;
      }
      if (array.length >= 10) {
        return array.slice(0, state.selected_number);
      } else {
        return array;
      }
    },
    TO_LIKED_DETAIL(state, news) {
      state.news_content.liked = !state.news_content.liked;
      if (state.news_content.liked) {
        state.news_content.likes = parseInt(state.news_content.likes, 10) + 1;
      } else {
        state.news_content.likes = parseInt(state.news_content.likes, 10) - 1;
      }
    },
  },
  actions: {
    show_number({state, commit}, event) {
      commit('CLEAR_PAGES');
      commit('SHOW_NUMBER', {array: state.comments, selected: event});
    },
    add_comment({commit, getters, rootGetters, dispatch}, comment) {
      const user    = rootGetters['profile/user/user'];
      let new_comment = {
        author: {
          id     : user.id,
          name   : user.name + ' ' + user.family,
          avatar : user.avatar,
          chevron: user.chevron || '',
          rank   : user.rank || '',
        },
        text: comment.text,
      };
      commit('ADD_COMMENT', new_comment);
      dispatch('post_news_comment', new_comment);
    },
    async post_news_comment({commit, getters, dispatch}, new_comment) {
      const {current_id} = getters;
      try {
        await api.events.post_event_comment(current_id, new_comment);
        commit('CLOSE_MODAL', 'add_comment_modal');
        dispatch('get_news_comments', current_id);
      } catch (err) {
        console.error(err);
      }
    },
    async get_news_detail({commit, dispatch}, id) {
      try {
        const news = await api.events.get_event_by_id(id);
        commit('SET_NEWS_DETAIL', news.data);
        dispatch('get_news_comments', id);
      } catch (err) {
        console.error(err);
      }
    },
    async get_news_comments({commit}, id) {
      try {
        const comments = await api.events.get_event_comments(id);
        commit('SET_COMMENTS', comments.data);
      } catch (err) {
        console.error(err);
      }
    },
    async edit_event_comment({commit, getters}, text) {
      const {current_id, current_edited_comment} = getters;
      let comment = current_edited_comment;
      try {
        await api.events.edit_event_comment(current_id, comment.id, {message: text});
        commit('EDIT_COMMENT_TEXT', {id: comment.id, value: text});
        commit('CLOSE_MODAL', 'modal_comment_edit');
      } catch (err) {
        console.error(err);
      }
    },
    async delete_event_comment({commit}, obj) {
      const {current_id, comment_id, reason} = obj;
      try {
        await api.events.delete_event_comment(current_id, comment_id);
        commit('DELETE_COMMENT', {id: comment_id, reason});
        commit('CLOSE_MODAL', 'modal_comment_edit');
      } catch (err) {
        console.error(err);
      }
    },
  },

};
